module.exports = __webpack_public_path__ + "static/media/freshly-married-couple-beside-carriage.05207b2d.jpg";